import { render, staticRenderFns } from "./detalhesDrAchei.vue?vue&type=template&id=384c58af&"
import script from "./detalhesDrAchei.vue?vue&type=script&lang=js&"
export * from "./detalhesDrAchei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports